// extracted by mini-css-extract-plugin
export default {"p":"home_p__w1cyM","loaderWrapper":"home_loaderWrapper__5gXX-","loader":"home_loader__7RPND","spin":"home_spin__QzD7T"};